import React from 'react'
import { connect } from 'react-redux'
import { Field, getFormValues, change } from 'redux-form'
import { Button } from 'semantic-ui-react'
import { withRouter } from 'react-router-dom'

import { StdCard } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { ApproveContainer, BottomActionsContainer } from './styled'
import { buttonColor } from '../../AttributeData'

const Approve = (props) => {
  
  const { 
    valueForm, 
  } = props

  return (
    (valueForm.sn && ((valueForm.actions || []).length > 0)) ?
      <StdCard title={<span className='stepTitle'>Action</span>} highlight enableCollapse={false}>
        <ApproveContainer>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Field
              name='comment'
              label='Your Comment'
              type={type.textArea}
              containerStyle={{ marginRight: '0px' }}
              component={FieldInput} />
            <BottomActionsContainer>
              {
                valueForm.actions.map((actionKey) => 
                  <Button
                    content={actionKey}
                    color={buttonColor[actionKey.replace(' & ','')]}
                    onClick={()=>{
                      props.change('formBGCompanyRequest','actionKey',actionKey)
                    }}
                  />)
              }
            </BottomActionsContainer>
          </div>
        </ApproveContainer>
      </StdCard>:null
  )
}

const mapStateToProps = (state) => {
  return ({
    valueForm: getFormValues('formBGCompanyRequest')(state) || {},
  })
}

const mapDispatchToProps = {
  change
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Approve))
